import { useSiteConfig } from 'hooks/useSiteConfig';

export const EmplifiEndOfPDPWidget = ({ sku }: { sku: string }) => {
  const { staticFeatures } = useSiteConfig();

  if (!staticFeatures.isPNARegion || !sku) return null;

  return (
    <>
      <div id="tt-reviews-summary"></div>
      <div id="tt-reviews-list"></div>
    </>
  );
};
